import { createAction, props } from '@ngrx/store'
import { AccountStatus } from '../../account-status.enum'

export const accountStatusReceived = createAction(
  '[AccountStatusInterceptor] Account Status Received',
  props<{ accountStatus: AccountStatus }>(),
)

export const setTemporaryBlockExpiration = createAction(
  '[AccountStatusInterceptor] Set Temporary Block Expiration',
  props<{ date: Date }>(),
)
